module.exports = __webpack_public_path__ + "img/amazon.472a7bbd.svg";